export default "__VITE_ASSET__BVTGKDpr__"